import {createStateMaker} from '@shared/helpers/object'

import {REGISTER_TYPE, SUBSCRIPTION_TYPE} from '../constants'
import {SubscribeState} from '../interfaces'

export const getInitialState = (): SubscribeState => {
    return {
        autoseq: null,
        cancelResponse: null,
        subscriptionType: SUBSCRIPTION_TYPE.NEW,
        failedReason: '',
        customInfos: {},
        registerType: REGISTER_TYPE.DEFAULT,
        /* 1000 - 성공케이스의 코드를 기본값으로 설정합니다. */
        orderSheetResponseCode: 1000,
        reRegistration: false,
        orderProcessId: '',
        isPayPointExcluded: false,
    }
}

export const makeMock = createStateMaker<SubscribeState>(getInitialState)
